import { render, staticRenderFns } from "./CancelledRemittances.vue?vue&type=template&id=d5ffb6a6&"
import script from "./CancelledRemittances.vue?vue&type=script&lang=js&"
export * from "./CancelledRemittances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports